let _cid = 0;

export function newCommentId() {
  _cid += 1;
  return `c${Date.now().toString(36)}_${_cid}`;
}

export function normalizeComments(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((c) => c && typeof c === 'object' && String(c.text || '').trim())
    .map((c) => ({
      id: c.id || newCommentId(),
      text: String(c.text).trim(),
      user_id: c.user_id != null ? Number(c.user_id) : null,
      user_name: c.user_name ? String(c.user_name) : null,
      created_at: c.created_at || new Date().toISOString(),
    }));
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('User');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function memberLabel(member) {
  if (!member) return '';
  return member.name || member.email || `User ${member.userId}`;
}

export function memberById(members, userId) {
  if (userId == null) return null;
  return (members || []).find((m) => Number(m.userId) === Number(userId)) || null;
}

/** Resolve the canonical origin kind for a row. */
export function originKind(origin) {
  if (!origin || typeof origin !== 'object') return null;
  if (origin.span_id) return 'trace';
  if (origin.experiment_id) return 'experiment';
  return origin.source_kind || origin.import_kind || null;
}

/** Short label for the Origin column / drawer. */
export function originLabel(origin) {
  if (!origin || typeof origin !== 'object') return null;
  const kind = originKind(origin);
  if (kind === 'trace') {
    const short = String(origin.span_id).replace(/-/g, '').slice(0, 6);
    return `Trace #${short}`;
  }
  if (kind === 'experiment') {
    if (origin.experiment_name) return `Exp "${origin.experiment_name}"`;
    const short = String(origin.experiment_id).replace(/-/g, '').slice(0, 6);
    return `Exp #${short}`;
  }
  if (kind === 'csv') return 'CSV';
  if (kind === 'json') return 'JSON';
  if (kind === 'jsonl') return 'JSONL';
  if (kind === 'sdk') return 'SDK';
  if (kind === 'spreadsheet') return 'Spreadsheet';
  if (kind === 'manual') return 'Manual';
  return null;
}

export function originTitle(origin) {
  if (!origin || typeof origin !== 'object') return undefined;
  const kind = originKind(origin);
  const file = origin.filename ? String(origin.filename) : null;
  if (kind === 'csv') return file ? `Imported from CSV · ${file}` : 'Imported from CSV';
  if (kind === 'json') return file ? `Imported from JSON · ${file}` : 'Imported from JSON';
  if (kind === 'jsonl') return file ? `Imported from JSONL · ${file}` : 'Imported from JSONL';
  if (kind === 'sdk') return 'Added via Trodo SDK';
  if (kind === 'spreadsheet') return file ? `Imported from file · ${file}` : 'Imported from spreadsheet';
  if (kind === 'trace') return `Source trace ${origin.span_id}`;
  if (kind === 'experiment') return origin.experiment_name || `Source experiment ${origin.experiment_id}`;
  return undefined;
}

export function importOriginFromFilename(filename) {
  const lower = String(filename || '').toLowerCase();
  if (lower.endsWith('.json')) return { source_kind: 'json', import_kind: 'json', filename };
  if (lower.endsWith('.jsonl') || lower.endsWith('.ndjson')) {
    return { source_kind: 'jsonl', import_kind: 'jsonl', filename };
  }
  if (lower.endsWith('.csv') || lower.endsWith('.tsv')) {
    return { source_kind: 'csv', import_kind: 'csv', filename };
  }
  if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) {
    return { source_kind: 'spreadsheet', import_kind: 'spreadsheet', filename };
  }
  return { source_kind: 'spreadsheet', import_kind: 'spreadsheet', filename };
}

export function importOriginFromKind(kind, filename = null) {
  const k = String(kind || '').toLowerCase();
  if (k === 'csv' || k === 'json' || k === 'jsonl' || k === 'sdk') {
    return { source_kind: k, import_kind: k, ...(filename ? { filename } : {}) };
  }
  return null;
}
